import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ResearchPageComponent } from "./research-page/research-page.component";
import { MoreAnalystResearchComponent } from "./more-analyst-research/more-analyst-research.component";
import { TickerSelectorComponent } from "./ticker-selector/ticker-selector.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IconsModule } from "@va/core-library/icons";
import { SharedModule } from "../shared/shared.module";
import { ResearchViewerComponent } from "./research-viewer/research-viewer.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";

import { ResearchChartCarouselComponent } from "./research-chart-carousel/research-chart-carousel.component";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
// ant modules
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzCarouselModule } from "ng-zorro-antd/carousel";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzAutocompleteModule } from "ng-zorro-antd/auto-complete";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzMenuModule } from "ng-zorro-antd/menu";

const routes: Routes = [
  {
    path: ":researchDocId",
    redirectTo: ":researchDocId/",
    pathMatch: "full",
  },
  {
    path: ":researchDocId/:ticker",
    component: ResearchPageComponent,
    data: {
      title: "Research Page",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResearchPageRoutingModule {}

@NgModule({
  declarations: [
    ResearchPageComponent,
    MoreAnalystResearchComponent,
    ResearchViewerComponent,
    TickerSelectorComponent,
    ResearchChartCarouselComponent,
  ],
  imports: [
    CommonModule,
    ResearchPageRoutingModule,
    FormsModule,
    IconsModule,
    SharedModule,
    InfiniteScrollModule,
    ChartPlotterModule,
    ReactiveFormsModule,
    NzSelectModule,
    NzCarouselModule,
    NzLayoutModule,
    NzInputModule,
    NzAutocompleteModule,
    NzTableModule,
    NzSkeletonModule,
    NzGridModule,
    NzButtonModule,
    NzMenuModule,
  ],
})
export class ResearchPageModule {}
